import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux'
import * as cartActions from './../../action/cart';
import { InHomeUtils } from './../../../src/util/inhomeUtils'
import { updateSCTags } from './../../service/dtmTag';
import { updateVzdlSCCustomEvent,tempVzdlSCData } from './../../service/vzdl';
import { Button, TextLink } from '@vds/buttons';
import { Body, Micro, Title } from '@vds/typography';
import { TileContainer } from "@vds/tiles";
import { Line } from '@vds/lines';
import DowncaretIcon from '@vds/icons/down-caret';
import UpcaretIcon from '@vds/icons/up-caret';
import ShoppingBag from '@vds/icons/shopping-bag';
import { detectClient } from '../../util/detectClient';
import {getPerkActualPrice } from './../midnight/services/dataFormatter';

const SaveMiniCart = props => {

    const { appState, cartState,buildProductState, checkoutState, visitId, dispatch, onOpenModal, onhandleKeyDownKeyDown, isEnableSave, nsiPage, btnData, isMobile, isTablet, openMiniCartModal, isMiniSubHeader,isStreamline } = props;
    const pathName = window.location.pathname;
    let popularPlanPage = pathName === '/inhome/popularPlans' ? true: false;
    let totalAmount = 0;
    let totalSavings = 0;
    let secTotalPrice = ''; 
    let isSetupFeeWaived= false; 
    let currClient = detectClient();
    let isCartDataEmpty = cartState?.cartData !== null && cartState?.cartData?.length !== 0 ? true : false;
    const [activeTabIndex, setactiveTabIndex] = useState(cartState.splitBillTab);    
    let splitBillTab = activeTabIndex;

    if (InHomeUtils.isNotNull(cartState?.cartHeader) && cartState?.cartHeader?.length > 0) {
        totalAmount=(cartState?.cartHeader?.[0]?.monthlyRcPrice !== null ? cartState?.cartHeader?.[0]?.monthlyRcPrice : totalAmount);
        // setTotalSavings(getMonthlySavingsPrice);
        /**Total Savings block of code*/
        {/**Perks Discount */}
        if (isCartDataEmpty && cartState?.cartData?.[splitBillTab]?.perks !== undefined && cartState?.cartData?.[splitBillTab]?.perks !== null && cartState?.cartData?.[splitBillTab]?.perks?.perks !== undefined
            && cartState?.cartData?.[splitBillTab]?.perks?.perks !== null && cartState?.cartData?.[splitBillTab]?.perks?.perks?.length > 0) {
                totalSavings = parseFloat(totalSavings ? totalSavings?.replace('-$', '') : 0);
                const perks = cartState?.cartData?.[splitBillTab]?.perks?.perks;
                const perksInSavings = perks?.map((perk, index) => {
                let perkActPrice;
                if(perk?.keyword) {
                    const perkMrp = perk?.keyword?.split('MRP:')?.[1];
                    perkActPrice = perkMrp?.split('|')?.[0];
                } else {
                    perkActPrice = getPerkActualPrice(perk?.prodId);
                }
                const perkSavings = (parseFloat(perkActPrice) - parseFloat(perk.price.replace('$','')))?.toFixed(2);
                const perkSavingsPrice = (parseFloat(perkActPrice) - parseFloat(perk?.bundleActucalPrice)).toFixed(2);
                totalSavings = parseFloat(totalSavings) + parseFloat(perkSavingsPrice);              
                return perk;
                });
            }{/**Perks Discount End */}
        
            {/**Promotions discount */}
            if (
            isCartDataEmpty &&
            cartState?.cartData?.[splitBillTab]?.Promotions &&
            InHomeUtils.isNotNull(cartState?.cartData?.[splitBillTab]?.Promotions?.promotions) &&
            cartState?.cartData?.[splitBillTab]?.Promotions?.promoSectionTotalPrice
            ) {
                let perkPremiumsaving=0;
                let totalperkPremiumSaving=0;
      perkPremiumsaving=cartState.cartData[splitBillTab].Promotions.promotions.filter(item=>item?.promoId==="R4540");
      perkPremiumsaving=perkPremiumsaving?.length>0?perkPremiumsaving:0;
      totalperkPremiumSaving=perkPremiumsaving?.[0]?.price;
      totalperkPremiumSaving=totalperkPremiumSaving?.length>0?totalperkPremiumSaving:0;
                secTotalPrice =cartState?.cartData?.[splitBillTab]?.Promotions?.promoSectionTotalPrice?.replace("$-","");
                secTotalPrice =secTotalPrice?.replace("$","");
                if (secTotalPrice !== undefined) {
                secTotalPrice = Math.floor(secTotalPrice);
                }
                totalSavings= '$' + (totalSavings ? parseFloat(totalSavings) + parseFloat(secTotalPrice)-totalperkPremiumSaving : parseFloat(( secTotalPrice)))?.toFixed(2) + '/mo';
            }
        
        if(totalSavings === '$0.00/mo' || totalSavings === '$0.00' || totalSavings === '0.00')
        {
            totalSavings = 0;
        }
            
    }


    if (
        isCartDataEmpty &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge !== undefined &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge !== undefined &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge !== null &&
        cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge?.length > 0
    ) {
        let setup = cartState?.cartData[splitBillTab]?.oneTimeCharge?.onetimecharge?.filter((p) => p?.prodType === 'SETUP');
        if (setup !== null && setup?.length > 0 && setup[0].price !== null) {
            if (setup[0].price === 'Fee Waived') {
                isSetupFeeWaived = true;
            }
        }
    }
    const isMax500plan = buildProductState?.internet?.m2mPlans?.findIndex(item => ["R3582", "R3583"].includes(item?.id)) > -1 ? false : true;
    if (isCartDataEmpty) {
        cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.map((serviceheaditems, index) => {
            if (serviceheaditems?.prodName?.includes("Gig") || buildProductState?.internet?.isFeeWaivedForAll || buildProductState?.internet?.isInstallFeeWaivedAllPrd || (isMax500plan && serviceheaditems?.prodName?.includes('500'))) {
                if (serviceheaditems?.prodName?.includes("Gig") || buildProductState?.internet?.isInstallFeeWaivedAllPrd) {
                    isSetupFeeWaived = true;
                }
                if (isMax500plan && serviceheaditems?.prodName?.includes('500')) {
                    if (checkoutState?.accordionStatus?.creditCheck !== "completed") {
                        isSetupFeeWaived = false;
                    }
                    else if (checkoutState.accordionStatus?.creditCheck === "completed" && checkoutState?.eligibleInstallation === "TechOnly" && checkoutState?.selDueDateType === "TECHVISIT") {
                        isSetupFeeWaived = false;
                    } else if (checkoutState.accordionStatus?.creditCheck === "completed" && (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || checkoutState?.selDueDateType === 'EONTSELFINSTALL')) {
                        isSetupFeeWaived = false;
                    }
                }
                if (serviceheaditems?.prodName?.includes("Gig") && (checkoutState?.selDueDateType_new === "EONTSELFINSTALL" || checkoutState?.selDueDateType === 'EONTSELFINSTALL') && checkoutState.accordionStatus?.creditCheck === "completed") {
                    isSetupFeeWaived = false;
                }
            }
        });
    }

    // const tvVoiceRedirection = (e) => {
    //     checkUpsellRecommendation(true) ;
    // }
    
    const onCartClick = (e) => { 
        //e.stopPropagation();
        if (!cartState?.isCartOpen) {
            updateSCTags("cart open");
            if(window && window.location && window.location.pathname && window.location.pathname?.includes('buildproducts')){
                tempVzdlSCData.name = "buildproducts";
                updateVzdlSCCustomEvent("cartView", "cartView", "name");
            }
            else if(window && window.location && window.location.pathname && window.location.pathname.includes('checkout')){
                tempVzdlSCData.name = "checkout";
                updateVzdlSCCustomEvent("cartView", "cartView", "name");
            }
            else if(window && window.location && window.location.pathname && window.location.pathname.includes('streamlineordering')){
                tempVzdlSCData.name = "Streamline Buildproducts - Internet & Perks";
                updateVzdlSCCustomEvent("cartView", "cartView", "name");
            }
            else{
                updateVzdlSCCustomEvent("cartView", "cartView", "");
            }
        }
        else {
            updateSCTags("cart close");
            cartActions.splitBillTab(0, dispatch)
        }
        cartActions.cartToggle("", dispatch, appState.visitId,buildProductState)
        if (appState.mobileHelpReveal) {
            cartActions.mobileHelpReveal(appState.mobileHelpReveal, dispatch);
        }
        
        isMobile && openMiniCartModal(!isMiniSubHeader);
    }

    const handleKeyDown = (e) => {

        if(e.type==='click' || e.key=== 'Enter' || e.key=== ' '){
            onCartClick(e)  
        }
    const cartElement=document.getElementById("setFocusToCartElement");
      if(!cartElement)return;
        const key=e.key
        const keyCode=e.keyCode
        setTimeout(()=>{
          if(cartState?.isCartOpen){
            if(e.type==='click' || e.key=== 'Enter' || e.key=== ' '){
                onCartClick(e)  
            }
            if(key==="Tab" || keyCode===9){
                cartElement.focus();
            }
          }
        },0)

        if (e.keyCode === 13 || e.keyCode === 32) {
            onCartClick(e);
        }
    }

    const buttonRedirectionHandler =(e) => {        
        e.stopPropagation();
        btnData?.onClick();   
    }
    let isStreamlinePage=false;
    if (pathName === '/inhome/streamlineordering' || pathName ==='/inhome/streamlinetvvoice' || props?.streamlineLQ){
        isStreamlinePage = true;
    }
    const getSaveCartSection = () =>{
        return !isMobile 
        ? 
            <div className={`topnav_userlinks ${isTablet && 'marginLeft20 width50'}`} style={{gap:'16px', display: 'inline-flex'}}>
               {!isStreamlinePage &&   <div className={`margin-top-micro ${isTablet ? 'margin-top-medium saveCartWidth' : (popularPlanPage && !isMobile ? '' : 'margin-left-large mozAmountHeader')}`} style={{ textWrap: 'nowrap' }} >
                {(nsiPage  || buildProductState?.isACPFlag || appState?.flowType==='MV') ? '' : <div style={{fontSize: isTablet ? '12px' : ''}}>
                    <TextLink 
                    type="standAlone"
                    size="small" 
                    id="SAVE"
                    onClick={e => onOpenModal(e)}
                    onKeyDown={e => onhandleKeyDownKeyDown(e)}
                    tabIndex={cartState?.isCartOpen ? "1" : "0"}
                    >
                    Save cart
                </TextLink></div>}
                </div>  }                          
            
                <div className = {isTablet ? 'tabletStickyHeader' : 'mozStickyHeader'} style={{paddingLeft:'10px'}}>  
                    <div id="BillCartTop" tabIndex="0" onKeyDown={(e) => handleKeyDown(e)}> 
                <TileContainer tabIndex={"-1"} padding="5px" backgroundColor={isStreamlinePage ? '#ffffff' :'secondary'} ariaLabel={!cartState?.isCartOpen ?`Pricing information about your ${totalAmount}/mo ${totalSavings} Savings Plan Collapsed`:`Pricing information about your ${totalAmount}/mo ${totalSavings} Savings Plan Expanded`} aspectRatio="none" width='auto' onClick={(e) => onCartClick(e)}>
                    <div aria-hidden="true" className={isTablet ? 'totalAmountTablet' : 'padding-left-micro padding-right-tiny'} >
                        {isTablet ? <Body size="medium" primitive='h3'>{totalAmount}/mo*</Body> : <Title  primitive='h3' size="small">{totalAmount}/mo*</Title>
                        }
                    </div>                                     
                    {totalSavings!==0 && <>
                         <Line orientation="vertical" type="secondary" color='#D8DADA' surface="light">
                        </Line><div aria-hidden="true" className={isTablet ? 'totalSavingsTablet' : 'padding-left-tiny'} style={{color:'#008331', textWrap: 'nowrap'}}>{isTablet ? <Body color='#008331' size="medium" primitive='h3'>{totalSavings} Savings </Body> : <Title color='#008331' size="small" primitive='h3'>{totalSavings} Savings </Title>}</div>
                    </>}
                    <div className={isTablet ? 'downIconTablet' : 'padding-left-tiny padding-right-tiny'} style={{marginTop: "5px"}}>
                    {!cartState?.isCartOpen ? (<DowncaretIcon size="small" color='#000000' ariaHidden={true} />) : (<UpcaretIcon size="small" color='#000000' ariaHidden={true} />)}
                        
                    </div>                    
                </TileContainer>    
                </div>                   
            </div>
            
            </div>
        :
        <div>
            
            <div className={pathName === '/inhome/popularPlans' ? 'w_Sticky_Popularplans_Footer padding-top-micro' : 'w_Sticky_Footer'}>
                <div>
                    <div>
                        {pathName === '/inhome/popularPlans' ? <>
                            <TileContainer padding="8px" aspectRatio="none" width="100%" onClick={(e) => onCartClick(e)} onKeyDown={(e) => handleKeyDown(e)}>
                                <div style={{ margin: "0px 3px 0px 0px"}} className="padding-left-medium">
                                    <ShoppingBag size="medium" color='#000000' />
                                </div>
                                <div className='padding-left-micro padding-right-tiny'><Title size="small">{totalAmount}/mo*</Title></div>
                                
                                {totalSavings !== 0 && <>
                                <Line orientation="vertical" type="secondary" color='#D8DADA' surface="light"></Line>
                                <div className='padding-left-tiny ' style={{ color: '#008331' }}><Title color='#008331' size="small">{totalSavings} saved </Title></div></>} 
                                <div className="downCaretsizePopular">
                                <DowncaretIcon size="small" color='#000000'></DowncaretIcon>
                                </div>
                            </TileContainer>  </> :
                            <div className={` ${window && window.location && window.location.pathname && window.location.pathname.includes('streamlinetvvoice')? 'cartFooterStreamLineTv' : ''} ${window && window.location && window.location.pathname && window.location.pathname.includes('ordersummary') ? "ordrSummaryFooterStreamlineMob" : ""}`} style={{height:'44px'}}>
                                    <TileContainer padding="6px" aspectRatio="none" width="100%" onClick={(e) => onCartClick(e)} onKeyDown={(e) => handleKeyDown(e)}>
                                <div style={{ margin: `5px 8px 0px 0px` }}>
                                    <ShoppingBag size="medium" color='#000000'></ShoppingBag>
                                </div>
                               {(isMobile || isTablet) && window && window.location && window.location.pathname && window.location.pathname.includes('streamlineordering') ? 
                                     <DowncaretIcon size="small" color='#000000'></DowncaretIcon>
                                :
                                <div className={`padding-right-medium appfbAlignCenter ${(currClient.browserType && currClient.browserType === 'safari') ? 'appfbAlignCenterSafari' : ''}`}>     
                                    <Body size="medium">{totalAmount}/mo* <span className="downCaretsize">
                                <DowncaretIcon size="small" color='#000000' ></DowncaretIcon>
                                </span> 
                                        { totalSavings!==0 && pathName !== '/inhome/checkout' &&  pathName !== '/inhome/moves/checkout' && <Micro color='#008331'>{totalSavings} saved </Micro>}
                                        { pathName ===  "/inhome/checkout" && checkoutState?.accordionStatus?.creditCheck === "completed" && checkoutState?.accordionStatus?.installation === "required" && isSetupFeeWaived && <Micro color="#6E6B65" >$99 waived for Fios setup. </Micro>}
                                    </Body>
                                </div>
                                }                           
                            </TileContainer>
                            </div>
                            }
                    </div>
                </div>
                <div style={{ display: 'flex' }}>
               { (isMobile || isTablet) && ((window && window.location && window.location.pathname && window.location.pathname.includes('streamlineordering') ||  window && window.location && window.location.pathname && window.location.pathname.includes('streamlinetvvoice')|| pathName ==='/inhome/ordersummary') && isStreamline)? <>
               {/* {window.location.pathname==="/inhome/ordersummary" || window.location.pathname==="/inhome/streamlinetvvoice" ? '' : <span style={{"padding-top":"15px", "margin-right":"0.5rem", "margin-left":"0.5rem"}}><TextLink onClick={()=>tvVoiceRedirection()}>Explore TV & Phone</TextLink></span>} */}
                {/* <div className="appfbAlignCenter right-section">
                        {btnData && btnData?.btnName && <Button primary size="small" type="primary" width="100%" disabled={btnData?.disabled} onClick={(e)=>{buttonRedirectionHandler(e)}} >
                            {'Review Order'}
                        </Button>}
                    </div> */}
                </>
                : 
                    <div className="appfbAlignCenter">
                        {btnData && btnData?.btnName && <Button primary size="small" type="primary" width="100%" disabled={btnData?.disabled} onClick={(e)=>{buttonRedirectionHandler(e)}} >
                            {btnData?.btnName}
                        </Button>}
                    </div>
                }
                </div>
            </div>
        </div>;
    }

    useEffect(() =>{

    },[isMobile, isTablet])



    return(
        <>
        {
            getSaveCartSection()

        }
        </>
    )
}

const mapStateToProps = state => {
    return {
      appState: state.app, 
      cartState: state.cart,  
      buildProductState: state.buildProduct,   
      visitId: state.app.visitId,
      checkoutState: state.checkout,
    }
  }
  
  export default React.memo(connect(mapStateToProps)(SaveMiniCart));